<template>
  <div>
    <el-row>
      <el-col :span="20">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="退货日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="left" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="exportOrder">导出订单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog title="选择日期" center :visible.sync="exportTatolDialog" width="600px">
      <el-form :model="exportForm" ref="exportForm" size="small" :inline="true" style="text-align: center">
        <el-form-item>
          <span>起始日期：</span>
          <el-date-picker @change="pickerD" v-model="exportForm.DAY_INTERVAL" type="daterange" align="left" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitExportDate" v-if="pickerN === ''" disabled>确 定</el-button>
        <el-button size="small" @click="submitExportDate" v-else>确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border :span-method="objectSpanMethod">
          <el-table-column label="序号" prop="SN" width="50px"></el-table-column>
          <el-table-column label="送货日期" prop="SEND_DAY"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME"></el-table-column>
          <el-table-column label="档口" prop="DK_NAME"></el-table-column>
          <el-table-column label="退货商品" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="退货总数" prop="TOTAL_RETURN_COUNT"></el-table-column>
          <el-table-column label="退货批次" prop="BATCH" width="145px"></el-table-column>
          <el-table-column label="退货数量" prop="BATCH_COUNT" min-width="80px"></el-table-column>
          <el-table-column label="退货理由" prop="REASON"></el-table-column>
          <el-table-column label="申请时间" prop="CREATE_TIME" width="160"></el-table-column>
          <el-table-column label="申请人" prop="NAME"></el-table-column>
          <el-table-column label="联系电话" prop="CELLPHONE"></el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="openDetail(scope.row)">退货凭证</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="total_count" style="float: right"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryHaveReturnFun, exportDateFun } from 'api/returnCheck';

export default {
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total_count: 0,
      rowList: [],
      spanArr: [],
      position: 0,
      pickerN: '',
      searchForm: {
        DAY_INTERVAL: [],
      },
      exportForm: {
        DAY_INTERVAL: [],
      },
      exportTatolDialog: false,
    };
  },
  methods: {
    pickerD() {
      this.pickerN = this.exportForm.DAY_INTERVAL;
    },
    // ------------------------筛选
    querySearch() {
      this.currentPage = 1;
      this.queryList();
    },
    // ---------------------------------导出
    exportOrder() {
      this.exportTatolDialog = true;
    },
    // --------------------------关闭
    close() {
      this.exportTatolDialog = false;
    },
    // ---------------------------确认导出
    submitExportDate() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            STATUS: 1,
            START_DATE: this.exportForm.DAY_INTERVAL[0],
            END_DATE: this.exportForm.DAY_INTERVAL[1],
          };
          exportDateFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportTatolDialog = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // --------------------------------退货凭证
    openDetail(row) {
      this.$router.push({ path: '/haveCheckDetail' });
      sessionStorage.setItem('orderId', row.DETAIL_ID);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
    // ------------------------拉取数据
    queryList() {
      const params = {
        STATUS: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      queryHaveReturnFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL_COUNT;
          this.rowspan();
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    rowspan() {
      this.spanArr = [];
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData[index].SN === this.tableData[index - 1].SN) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 5) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 8) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 9) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 10) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 11) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 12) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/returnCheck/haveCheck.vue